import React, { useState, useEffect } from 'react';
import axios from 'axios';
const API = process.env.REACT_APP_API_URL || 'https://books.bloanshandbags.com/api';
const BRAND = { olive:'#556B2F', cream:'#F2EFE7', gold:'#A8893D', brown:'#3B2A21', red:'#8F2E24' };

export default function BiodataForm({ token }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [step, setStep] = useState(1);
  const [autoSaved, setAutoSaved] = useState(false);
  const TOTAL_STEPS = 6;
  const STORAGE_KEY = 'bloans_biodata_' + token;

  const emptyEdu = () => ({ degree:'', institution:'', year:'' });
  const emptyProf = () => ({ body:'', grade:'', year:'' });
  const emptyEmp = () => ({ name:'', address:'', phone:'', position:'', date_from:'', date_to:'', description:'' });
  const emptyChild = () => ({ name:'', sex:'', dob:'' });

  const [form, setForm] = useState({
    // Section 1 - Personal
    title:'', marital_status:'', maiden_name:'', date_of_birth:'',
    place_of_birth:'', nationality:'Nigerian', sex:'', state_of_origin:'',
    lga:'', permanent_address:'', residential_address:'', phone:'', email:'',
    // Section 1 - Health
    genotype:'', blood_group:'', health_history:'',
    // Section 2 - Education
    educational_history: [emptyEdu(), emptyEdu(), emptyEdu()],
    professional_qualifications: [emptyProf(), emptyProf()],
    // Section 3 - Employment
    employment_history: [emptyEmp(), emptyEmp(), emptyEmp()],
    // Section 4 - Family
    spouse_name:'', spouse_maiden_name:'', spouse_address:'',
    spouse_contact_address:'', spouse_email:'', spouse_phone:'',
    children: [emptyChild(), emptyChild(), emptyChild(), emptyChild()],
    father_name:'', father_phone:'', mother_name:'', mother_phone:'',
    // Emergency
    emergency_contact_name:'', emergency_contact_sex:'',
    emergency_contact_relationship:'', emergency_contact_phone:'', emergency_contact_email:'',
    // Section 5 - Criminal
    criminal_q1:'no', criminal_q2:'no', criminal_details:'',
    // Section 6 - Certification
    certified: false
  });

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed.form) setForm(f => ({...f, ...parsed.form}));
        if (parsed.step) setStep(parsed.step);
      } catch(e) {}
    }
    axios.get(`${API}/biodata/form/${token}`)
      .then(r => { setUser(r.data.data); })
      .catch(e => { setError(e.response?.data?.error || 'Invalid link'); })
      .finally(() => setLoading(false));
  }, [token]);

  const set = (k, v) => setForm(f => ({...f, [k]: v}));
  const setArr = (key, idx, field, val) => {
    setForm(f => {
      const arr = [...f[key]];
      arr[idx] = {...arr[idx], [field]: val};
      return {...f, [key]: arr};
    });
  };

  const saveProgress = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ form, step }));
    setAutoSaved(true);
    setTimeout(() => setAutoSaved(false), 2000);
  };

  const submit = async () => {
    if (!form.certified) { setError('Please certify that all information is true and correct.'); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/biodata/submit/${token}`, form);
      localStorage.removeItem(STORAGE_KEY);
      setSubmitted(true);
    } catch(e) { setError(e.response?.data?.error || 'Submission failed. Please try again.'); }
    finally { setSaving(false); }
  };

  const inp = {width:'100%',padding:'9px 12px',border:'1px solid #E8E0D4',borderRadius:7,
    fontSize:13,color:BRAND.brown,background:'#fff',boxSizing:'border-box',fontFamily:'Georgia,serif'};
  const lbl = {display:'block',fontSize:10,fontWeight:700,color:'#8A8A8A',textTransform:'uppercase',
    letterSpacing:'.07em',marginBottom:4};
  const secHdr = (n, t) => (
    <div style={{background:BRAND.olive,color:BRAND.cream,padding:'9px 14px',borderRadius:6,
      fontWeight:700,fontSize:11,textTransform:'uppercase',letterSpacing:'.1em',margin:'20px 0 14px'}}>
      Section {n}: {t}
    </div>
  );
  const field = (label, key, type='text', opts=null) => (
    <div style={{marginBottom:12}}>
      <label style={lbl}>{label}</label>
      {opts ? (
        <select style={inp} value={form[key]} onChange={e=>set(key,e.target.value)}>
          <option value="">Select...</option>
          {opts.map(o=><option key={o} value={o}>{o}</option>)}
        </select>
      ) : type==='textarea' ? (
        <textarea style={{...inp,minHeight:65}} value={form[key]} onChange={e=>set(key,e.target.value)}/>
      ) : (
        <input type={type} style={inp} value={form[key]} onChange={e=>set(key,e.target.value)}/>
      )}
    </div>
  );

  if (loading) return <div style={{minHeight:'60vh',display:'flex',alignItems:'center',justifyContent:'center',color:BRAND.olive}}>Loading your form...</div>;

  if (submitted) return (
    <div style={{maxWidth:520,margin:'48px auto',padding:24,textAlign:'center'}}>
      <div style={{background:'#fff',borderRadius:16,padding:40,boxShadow:'0 4px 24px rgba(0,0,0,.08)'}}>
        <div style={{fontSize:52,marginBottom:16}}>✅</div>
        <h2 style={{fontFamily:'Georgia,serif',color:BRAND.olive,marginBottom:12}}>Form Submitted</h2>
        <p style={{color:'#555',fontSize:14,lineHeight:1.7}}>Thank you, <strong>{user?.name}</strong>. Your bio-data has been submitted and saved to your staff record.</p>
        <p style={{color:'#8A8A8A',fontSize:12,marginTop:16}}>You may close this window.</p>
      </div>
    </div>
  );

  if (error && !user) return (
    <div style={{maxWidth:520,margin:'48px auto',padding:24,textAlign:'center'}}>
      <div style={{background:'#fff',borderRadius:16,padding:40,boxShadow:'0 4px 24px rgba(0,0,0,.08)'}}>
        <div style={{fontSize:44,marginBottom:16}}>⚠️</div>
        <h2 style={{fontFamily:'Georgia,serif',color:BRAND.red,marginBottom:12}}>{error}</h2>
        <p style={{color:'#8A8A8A',fontSize:13}}>Contact HR at <a href="mailto:hr@bloanshandbags.com" style={{color:BRAND.olive}}>hr@bloanshandbags.com</a></p>
      </div>
    </div>
  );

  return (
    <div style={{maxWidth:800,margin:'0 auto',padding:'20px 16px',fontFamily:'Georgia,serif'}}>
      {/* Header */}
      <div style={{background:BRAND.brown,borderRadius:10,padding:'14px 18px',marginBottom:14}}>
        <div style={{color:BRAND.gold,fontSize:14,fontWeight:700}}>Employee Bio-Data Form</div>
        <div style={{color:'rgba(242,239,231,.6)',fontSize:12,marginTop:2}}>Bloans Creations Ltd. &nbsp;·&nbsp; <strong style={{color:'rgba(242,239,231,.8)'}}>{user?.name}</strong></div>
      </div>

      {/* Auto-save bar */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
        <div style={{fontSize:11,color:'#8A8A8A'}}>Progress saved automatically. You can close and return later.</div>
        <div style={{display:'flex',gap:6,alignItems:'center'}}>
          {autoSaved && <span style={{fontSize:11,color:BRAND.olive,fontWeight:600}}>✓ Saved</span>}
          <button onClick={saveProgress} style={{fontSize:11,padding:'4px 10px',borderRadius:6,
            border:'1px solid #E8E0D4',background:'#fff',cursor:'pointer',color:BRAND.brown}}>
            💾 Save
          </button>
        </div>
      </div>

      {/* Progress */}
      <div style={{background:'#fff',borderRadius:8,padding:'10px 16px',marginBottom:14,
        boxShadow:'0 1px 6px rgba(0,0,0,.05)'}}>
        <div style={{display:'flex',alignItems:'center',gap:6}}>
          {Array.from({length:TOTAL_STEPS},(_,i)=>(
            <React.Fragment key={i}>
              <div onClick={()=>setStep(i+1)} style={{width:26,height:26,borderRadius:'50%',
                display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,
                flexShrink:0,cursor:'pointer',
                background:i+1<step?BRAND.olive:i+1===step?BRAND.gold:'#E8E0D4',
                color:i+1<=step?'#fff':'#8A8A8A'}}>{i+1}</div>
              {i<TOTAL_STEPS-1 && <div style={{flex:1,height:2,background:i+1<step?BRAND.olive:'#E8E0D4'}}/>}
            </React.Fragment>
          ))}
        </div>
        <div style={{fontSize:11,color:'#8A8A8A',marginTop:6,textAlign:'center'}}>
          {['Personal Information & Health','Educational History','Employment History','Family & Dependants','Criminal Declaration','Certification'][step-1]}
        </div>
      </div>

      <div style={{background:'#fff',borderRadius:12,padding:24,boxShadow:'0 2px 14px rgba(0,0,0,.06)'}}>

        {/* STEP 1 - Personal & Health */}
        {step===1 && (
          <div>
            {secHdr(1,'Personal Information')}
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              {field('Title','title','text',['Mr','Mrs','Miss','Ms','Dr','Prof','Engr','Barr','Chief','Alhaji','Alhaja'])}
              {field('Marital Status','marital_status','text',['Single','Married','Divorced','Widowed','Separated'])}
              {field('Maiden Name (if applicable)','maiden_name')}
              {field('Date of Birth','date_of_birth','date')}
              {field('Place of Birth','place_of_birth')}
              {field('Nationality','nationality')}
              {field('Sex','sex','text',['Male','Female'])}
              {field('State of Origin','state_of_origin')}
              {field('LGA','lga')}
              {field('Phone No(s)','phone')}
            </div>
            <div style={{marginBottom:12}}>
              <label style={lbl}>Permanent Home Address</label>
              <textarea style={{...inp,minHeight:60}} value={form.permanent_address} onChange={e=>set('permanent_address',e.target.value)}/>
            </div>
            <div style={{marginBottom:12}}>
              <label style={lbl}>Current Residential Address</label>
              <textarea style={{...inp,minHeight:60}} value={form.residential_address} onChange={e=>set('residential_address',e.target.value)}/>
            </div>
            {secHdr(1,'Health Record')}
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              {field('Genotype','genotype','text',['AA','AS','SS','AC','SC'])}
              {field('Blood Group','blood_group','text',['A+','A-','B+','B-','AB+','AB-','O+','O-'])}
            </div>
            {field('Health History (Common Ailments if any)','health_history','textarea')}
          </div>
        )}

        {/* STEP 2 - Education */}
        {step===2 && (
          <div>
            {secHdr(2,'Educational History')}
            <p style={{fontSize:12,color:'#8A8A8A',marginBottom:14}}>Starting with the most recent qualification.</p>

            <div style={{fontWeight:700,fontSize:12,color:BRAND.brown,marginBottom:10}}>Academic Qualifications</div>
            {form.educational_history.map((edu,i)=>(
              <div key={i} style={{background:'#F9F8F5',borderRadius:8,padding:14,marginBottom:10,border:'1px solid #E8E0D4'}}>
                <div style={{fontSize:11,fontWeight:700,color:BRAND.olive,marginBottom:10}}>Qualification {i+1}</div>
                <div style={{display:'grid',gridTemplateColumns:'2fr 2fr 1fr',gap:10}}>
                  <div>
                    <label style={lbl}>Degree / Qualification</label>
                    <input style={inp} value={edu.degree} onChange={e=>setArr('educational_history',i,'degree',e.target.value)} placeholder="e.g. B.Sc Computer Science"/>
                  </div>
                  <div>
                    <label style={lbl}>Institution</label>
                    <input style={inp} value={edu.institution} onChange={e=>setArr('educational_history',i,'institution',e.target.value)}/>
                  </div>
                  <div>
                    <label style={lbl}>Year</label>
                    <input style={inp} type="number" value={edu.year} onChange={e=>setArr('educational_history',i,'year',e.target.value)} placeholder="yyyy"/>
                  </div>
                </div>
              </div>
            ))}

            <div style={{fontWeight:700,fontSize:12,color:BRAND.brown,margin:'16px 0 10px'}}>Professional Qualifications</div>
            {form.professional_qualifications.map((pq,i)=>(
              <div key={i} style={{background:'#F9F8F5',borderRadius:8,padding:14,marginBottom:10,border:'1px solid #E8E0D4'}}>
                <div style={{fontSize:11,fontWeight:700,color:BRAND.olive,marginBottom:10}}>Professional Qualification {i+1}</div>
                <div style={{display:'grid',gridTemplateColumns:'2fr 1fr 1fr',gap:10}}>
                  <div>
                    <label style={lbl}>Professional Body</label>
                    <input style={inp} value={pq.body} onChange={e=>setArr('professional_qualifications',i,'body',e.target.value)} placeholder="e.g. ICAN, NSE"/>
                  </div>
                  <div>
                    <label style={lbl}>Grade of Membership</label>
                    <input style={inp} value={pq.grade} onChange={e=>setArr('professional_qualifications',i,'grade',e.target.value)} placeholder="e.g. Member, Fellow"/>
                  </div>
                  <div>
                    <label style={lbl}>Year</label>
                    <input style={inp} type="number" value={pq.year} onChange={e=>setArr('professional_qualifications',i,'year',e.target.value)} placeholder="yyyy"/>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* STEP 3 - Employment History */}
        {step===3 && (
          <div>
            {secHdr(3,'Employment History')}
            <p style={{fontSize:12,color:'#8A8A8A',marginBottom:14}}>Starting with the most recent, including contract jobs.</p>
            {form.employment_history.map((emp,i)=>(
              <div key={i} style={{background:'#F9F8F5',borderRadius:8,padding:14,marginBottom:14,border:'1px solid #E8E0D4'}}>
                <div style={{fontSize:11,fontWeight:700,color:BRAND.olive,marginBottom:10}}>Organisation {i+1}</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                  <div><label style={lbl}>Organisation Name</label><input style={inp} value={emp.name} onChange={e=>setArr('employment_history',i,'name',e.target.value)}/></div>
                  <div><label style={lbl}>Position</label><input style={inp} value={emp.position} onChange={e=>setArr('employment_history',i,'position',e.target.value)}/></div>
                  <div><label style={lbl}>Address</label><input style={inp} value={emp.address} onChange={e=>setArr('employment_history',i,'address',e.target.value)}/></div>
                  <div><label style={lbl}>Tel No</label><input style={inp} value={emp.phone} onChange={e=>setArr('employment_history',i,'phone',e.target.value)}/></div>
                  <div><label style={lbl}>Date From</label><input type="date" style={inp} value={emp.date_from} onChange={e=>setArr('employment_history',i,'date_from',e.target.value)}/></div>
                  <div><label style={lbl}>Date To</label><input type="date" style={inp} value={emp.date_to} onChange={e=>setArr('employment_history',i,'date_to',e.target.value)}/></div>
                </div>
                <div style={{marginTop:10}}>
                  <label style={lbl}>Brief Description of Responsibilities</label>
                  <textarea style={{...inp,minHeight:60}} value={emp.description} onChange={e=>setArr('employment_history',i,'description',e.target.value)}/>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* STEP 4 - Family */}
        {step===4 && (
          <div>
            {secHdr(4,'Family / Dependants Information')}

            <div style={{fontWeight:700,fontSize:12,color:BRAND.brown,marginBottom:10}}>Spouse</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
              <div><label style={lbl}>Name</label><input style={inp} value={form.spouse_name} onChange={e=>set('spouse_name',e.target.value)}/></div>
              <div><label style={lbl}>Maiden Name</label><input style={inp} value={form.spouse_maiden_name} onChange={e=>set('spouse_maiden_name',e.target.value)}/></div>
              <div><label style={lbl}>Email Address</label><input type="email" style={inp} value={form.spouse_email} onChange={e=>set('spouse_email',e.target.value)}/></div>
              <div><label style={lbl}>Tel</label><input style={inp} value={form.spouse_phone} onChange={e=>set('spouse_phone',e.target.value)}/></div>
            </div>
            <div style={{marginBottom:12}}><label style={lbl}>Permanent Home Address</label><textarea style={{...inp,minHeight:55}} value={form.spouse_address} onChange={e=>set('spouse_address',e.target.value)}/></div>
            <div style={{marginBottom:16}}><label style={lbl}>Contact Address</label><textarea style={{...inp,minHeight:55}} value={form.spouse_contact_address} onChange={e=>set('spouse_contact_address',e.target.value)}/></div>

            <div style={{fontWeight:700,fontSize:12,color:BRAND.brown,marginBottom:10}}>Children</div>
            {form.children.map((child,i)=>(
              <div key={i} style={{display:'grid',gridTemplateColumns:'2fr 1fr 1fr',gap:10,marginBottom:8}}>
                <div><label style={lbl}>Child {i+1} Name</label><input style={inp} value={child.name} onChange={e=>setArr('children',i,'name',e.target.value)}/></div>
                <div><label style={lbl}>Sex</label><select style={inp} value={child.sex} onChange={e=>setArr('children',i,'sex',e.target.value)}><option value="">-</option><option>Male</option><option>Female</option></select></div>
                <div><label style={lbl}>Date of Birth</label><input type="date" style={inp} value={child.dob} onChange={e=>setArr('children',i,'dob',e.target.value)}/></div>
              </div>
            ))}

            <div style={{fontWeight:700,fontSize:12,color:BRAND.brown,margin:'16px 0 10px'}}>Parents</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
              <div><label style={lbl}>Father's Name</label><input style={inp} value={form.father_name} onChange={e=>set('father_name',e.target.value)}/></div>
              <div><label style={lbl}>Father's Phone</label><input style={inp} value={form.father_phone} onChange={e=>set('father_phone',e.target.value)}/></div>
              <div><label style={lbl}>Mother's Name</label><input style={inp} value={form.mother_name} onChange={e=>set('mother_name',e.target.value)}/></div>
              <div><label style={lbl}>Mother's Phone</label><input style={inp} value={form.mother_phone} onChange={e=>set('mother_phone',e.target.value)}/></div>
            </div>

            <div style={{fontWeight:700,fontSize:12,color:BRAND.brown,marginBottom:10}}>Next of Kin / In Case of Emergency</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div><label style={lbl}>Name</label><input style={inp} value={form.emergency_contact_name} onChange={e=>set('emergency_contact_name',e.target.value)}/></div>
              <div><label style={lbl}>Sex</label><select style={inp} value={form.emergency_contact_sex} onChange={e=>set('emergency_contact_sex',e.target.value)}><option value="">-</option><option>Male</option><option>Female</option></select></div>
              <div><label style={lbl}>Relationship</label><input style={inp} value={form.emergency_contact_relationship} onChange={e=>set('emergency_contact_relationship',e.target.value)}/></div>
              <div><label style={lbl}>Phone No</label><input style={inp} value={form.emergency_contact_phone} onChange={e=>set('emergency_contact_phone',e.target.value)}/></div>
              <div style={{gridColumn:'span 2'}}><label style={lbl}>Email</label><input type="email" style={inp} value={form.emergency_contact_email} onChange={e=>set('emergency_contact_email',e.target.value)}/></div>
            </div>
          </div>
        )}

        {/* STEP 5 - Criminal */}
        {step===5 && (
          <div>
            {secHdr(5,'Criminal Records Declaration')}
            <p style={{fontSize:13,color:'#555',marginBottom:16}}>Kindly answer the questions below honestly.</p>

            <div style={{background:'#F9F8F5',border:'1px solid #E8E0D4',borderRadius:8,padding:16,marginBottom:12}}>
              <p style={{fontSize:13,margin:'0 0 12px',lineHeight:1.8}}>Have you ever been convicted of a criminal offence or found guilty by a Court of any offence in any country, or have you ever been put on probation or absolutely/conditionally discharged or bound over after being charged with any offence, or is there any action pending against you?</p>
              <div style={{display:'flex',gap:24}}>
                {['yes','no'].map(v=>(
                  <label key={v} style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:14}}>
                    <input type="radio" name="cq1" value={v} checked={form.criminal_q1===v}
                      onChange={()=>set('criminal_q1',v)} style={{accentColor:BRAND.olive}}/>
                    {v.charAt(0).toUpperCase()+v.slice(1)}
                  </label>
                ))}
              </div>
            </div>

            <div style={{background:'#F9F8F5',border:'1px solid #E8E0D4',borderRadius:8,padding:16,marginBottom:12}}>
              <p style={{fontSize:13,margin:'0 0 12px',lineHeight:1.8}}>Are you currently or have you been involved in any activities which may compromise your position, including bias or prejudice in conduct of official duties, misuse of official information, or misappropriation of funds?</p>
              <div style={{display:'flex',gap:24}}>
                {['yes','no'].map(v=>(
                  <label key={v} style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:14}}>
                    <input type="radio" name="cq2" value={v} checked={form.criminal_q2===v}
                      onChange={()=>set('criminal_q2',v)} style={{accentColor:BRAND.olive}}/>
                    {v.charAt(0).toUpperCase()+v.slice(1)}
                  </label>
                ))}
              </div>
            </div>

            {(form.criminal_q1==='yes'||form.criminal_q2==='yes') && (
              <div>
                <label style={lbl}>Please provide details</label>
                <textarea style={{...inp,minHeight:100}} value={form.criminal_details} onChange={e=>set('criminal_details',e.target.value)}/>
              </div>
            )}
          </div>
        )}

        {/* STEP 6 - Certification */}
        {step===6 && (
          <div>
            {secHdr(6,'Certification')}
            <div style={{background:'#F9F8F5',border:'1px solid #E8E0D4',borderRadius:8,padding:18,
              fontSize:13,lineHeight:1.9,color:BRAND.brown,marginBottom:20}}>
              I HEREBY certify that all statements made in this document are true and correct to the best of my knowledge. I am aware and understand that by submitting this personal data form, the company reserves the right to verify statements and claims made therein without any recourse to any liability to me. Therefore, I understand and agree that my providing false or misleading information or withholding any required information will provide grounds for the termination of my employment.
            </div>
            <label style={{display:'flex',alignItems:'flex-start',gap:10,cursor:'pointer',marginBottom:20}}>
              <input type="checkbox" style={{accentColor:BRAND.olive,width:18,height:18,flexShrink:0,marginTop:2}}
                checked={form.certified} onChange={e=>set('certified',e.target.checked)}/>
              <span style={{fontSize:13,color:BRAND.brown,lineHeight:1.7}}>
                I, <strong>{user?.name}</strong>, certify that all information provided in this form is true, accurate and complete to the best of my knowledge.
              </span>
            </label>
            {error && <div style={{background:'#FDEAEA',border:'1px solid #F5B8B8',borderRadius:8,
              padding:'10px 14px',marginBottom:14,fontSize:13,color:BRAND.red}}>{error}</div>}
          </div>
        )}

        {/* Navigation */}
        <div style={{display:'flex',justifyContent:'space-between',marginTop:24,
          paddingTop:18,borderTop:'1px solid #E8E0D4'}}>
          {step>1 ? (
            <button onClick={()=>{saveProgress();setStep(s=>s-1);}}
              style={{padding:'10px 22px',borderRadius:8,border:'1px solid #E8E0D4',
                background:'#fff',cursor:'pointer',fontSize:14,color:BRAND.brown}}>
              ← Previous
            </button>
          ) : <div/>}
          <div style={{display:'flex',gap:8}}>
            {step<TOTAL_STEPS && (
              <button onClick={saveProgress}
                style={{padding:'10px 16px',borderRadius:8,border:'1px solid #E8E0D4',
                  background:'#fff',cursor:'pointer',fontSize:12,color:BRAND.brown}}>
                {autoSaved?'✓ Saved':'💾 Save'}
              </button>
            )}
            {step<TOTAL_STEPS ? (
              <button onClick={()=>{saveProgress();setStep(s=>s+1);}}
                style={{padding:'10px 26px',borderRadius:8,border:'none',
                  background:BRAND.olive,color:'#fff',cursor:'pointer',fontSize:14,fontWeight:600}}>
                Next →
              </button>
            ) : (
              <button onClick={submit} disabled={saving||!form.certified}
                style={{padding:'10px 26px',borderRadius:8,border:'none',
                  background:saving||!form.certified?'#ccc':BRAND.olive,
                  color:'#fff',cursor:saving||!form.certified?'not-allowed':'pointer',
                  fontSize:14,fontWeight:700}}>
                {saving?'Submitting...':'Submit Bio-Data Form'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
